export default __webpack_public_path__ + "static/media/darkSwapCard.8e0399e7.png";